import { render, staticRenderFns } from "./LiveTradesTable.vue?vue&type=template&id=47d7d210"
import script from "./LiveTradesTable.vue?vue&type=script&lang=js"
export * from "./LiveTradesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports